import common from "@/api/common";
import yioksStorage from "@/assets/js/yioksStorage";
import defaultHomeBg from '@/assets/images/common/homeBg.png'
import titlePicture from '@/assets/images/login/title_picture.png'
const systemConfig = 'SYSTEM_CONFIG'

export default {
  namespaced: true,
  // state: () => {

  // }
  state: {
    systemConfig: {
      sysFootContent: '',
      sysPlatformName: '',
      sysPlatformTelephone: '',
      sysHomeBackground: '',
      sysLoginBackground: '',
      // sysHomeBackground: '',
      sysTitleImage: '', // titlePicture
      sysPlatformCSQrcode: '',
      sysRegister: false,
      sysLogo: '',
      sysHostType: '',  // youth
      sysHostURL: '',
    },

  },


  mutations: {
    // 更新config
    updateConfig(state, row) {
      const rowData = Object.assign({}, state.systemConfig, row)
      state.systemConfig = rowData;
      yioksStorage.setItem(systemConfig, rowData)
    },

    // 清理config信息
    clearConfig(state) {
      state.systemConfig = null;
      yioksStorage.clearItem(systemConfig)
    }
  },

  actions: {
    setConfigSync({ commit }) {
      common.getConfigInfo()
        .then(res => {
          if (res) {
            commit('updateConfig', res);  // 更新用户信息
          } else {
            console.warn('update function is error for the res is:', res)
          }

        })
        .catch(err => {
          console.error('err', err)
        })
    }
  },


}
